// Prompt.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type PromptProps = {
    when: boolean;
    message: string;
};

const Prompt = ({ when, message }: PromptProps) => {

    const location = useLocation();

    useEffect(() => {
        if (!when) return;

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = message;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [when, message]);

    useEffect(() => {
        if (!when) return;

        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        const handleNavigation = (event: PopStateEvent) => {
            const confirmLeave = window.confirm(message);
            if (!confirmLeave) {
                event.preventDefault();
                window.history.pushState(null, '', location.pathname); // cancel navigation
            }
        };

        window.addEventListener('popstate', handleNavigation);

        return () => {
            window.removeEventListener('popstate', handleNavigation);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [when, message, location.pathname]);

    return null;
};

export default Prompt;
